export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Get In Touch
          </h2>
          <p className="text-xl text-gray-600">
            We're here to help with any questions you may have
          </p>
        </div>

        <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-5 gap-0">
            <div className="md:col-span-3 p-12 space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-lg mb-1">Email</h3>
                  <a href="mailto:contact@horaldoo.com" className="text-teal-600 hover:text-teal-700 transition-colors text-lg">
                    contact@horaldoo.com
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-lg mb-1">Phone</h3>
                  <a href="tel:+18048165363" className="text-gray-700 hover:text-teal-600 transition-colors text-lg">
                    +1 8048165363
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-lg mb-1">Address</h3>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    Ulica knezova Draskovica 25a<br />
                    23000 Zadar<br />
                    Croatia
                  </p>
                </div>
              </div>
            </div>

            <div className="md:col-span-2 bg-gradient-to-br from-teal-50 to-blue-50 p-12 flex items-center justify-center">
              <div className="text-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/f74328f40dba9bd4d48b4c9b2e02c27b.jpg"
                  alt="Croatia Map with Zadar Location"
                  className="w-full h-auto max-w-xs mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
